import React from 'react'
import _ from "lodash"

const NullAsDefault = () => null;
// console.log('.', NullAsDefault)

const renderSelf = (me) => me

const renderOwnChild = ({children}) => children

const renderIf = (condition = false, value) => (!!condition ? value : null)

const renderElse = (condition = false, value) => renderIf(!condition, value)

const renderIfElse = (condition = false, trueValue, falseValue) =>
    !!condition ? trueValue : falseValue

const renderWhere = (condition, render = NullAsDefault) =>
    !!condition ? render() : null

const withPagerWrapper =
    (render = renderSelf) =>
        (children, __, total = 0) =>
            renderWhere(total > 0, () => render(children))

const Visible = ({visible = false, invisible = false}, __) =>
    !!visible || !!!invisible

const renderCallback = (fn = NullAsDefault) => fn()

const renderTrue = () => true

const renderFalse = () => false

const renderPhone = (phone, renderBody = renderSelf, Wrapper = 'a') =>
    renderIf(
        phone,
        <Wrapper href={['tel:', phone].join('')}>{renderBody(phone)}</Wrapper>
    )

const renderMail = (mail, renderBody = renderSelf, Wrapper = 'a') =>
    renderIf(
        mail,
        <Wrapper href={['mailto:', mail].join('')}>{renderBody(mail)}</Wrapper>
    )

const renderMaybeFn = (value, ...args) => {
    if (typeof value === 'function') {
        return value(...args); // Gọi hàm với args nếu có
    }
    return value; // Nếu không phải function, trả nguyên
};

const safeRender = (value, ...args) => {
    if (!value) return null;
    if (React.isValidElement(value)) return value;
    if (typeof value === 'function') {
        const result = value(...args);
        if (result === null || result === undefined || React.isValidElement(result)) {
            return result;
        }
        // Caller truyền Component thay vì render fn → wrap thành JSX element
        const Comp = value;
        return <Comp/>;
    }
    return value;
};

const isDeepEmpty = (val) =>
    _.isEmpty(val) ||
    (_.isArray(val) && _.every(val, isDeepEmpty)) ||
    (_.isObject(val) && _.every(val, isDeepEmpty));

export const pagerControls = {
    search: {
        component: null,
        keyword: undefined,
    },
}

export {
    NullAsDefault,
    Visible,
    renderIf,
    renderElse,
    renderIfElse,
    renderMail,
    renderPhone,
    renderTrue,
    renderSelf,
    renderFalse,
    renderWhere,
    renderCallback,
    renderOwnChild,
    withPagerWrapper,
    renderMaybeFn,
    safeRender,
    isDeepEmpty
}
